export default function Button({ onClick, className, children, disabled }) {
  return (
    <button
      className={`${className} button`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

Button.defaultProps = {
  className: "",
  onClick: () => {},
  disabled: false,
};
